import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import css_248z from './footer-accordion.scss.js';
import '../footer-accordion-item/index.js';

class FooterAccordion extends s {
    constructor() {
        super(...arguments);
        this.onItemToggle = (e) => {
            var _a;
            const current = ((_a = e.composedPath().find(node => {
                return (node instanceof HTMLElement &&
                    node.tagName.toLowerCase() === 'footer-accordion-item');
            })) !== null && _a !== void 0 ? _a : e.target);
            this.items.forEach(it => {
                if (it !== current)
                    it.setAttribute('data-open', 'false');
            });
        };
        this.onKeyNav = (e) => {
            var _a, _b, _c, _d, _e;
            if (e.key === 'Escape') {
                this.items.forEach(i => i.setAttribute('data-open', 'false'));
                return;
            }
            const heads = this.items
                .map(i => { var _a; return (_a = i.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button'); })
                .filter(Boolean);
            const active = ((_a = e.composedPath()[0]) !== null && _a !== void 0 ? _a : e.target);
            const idx = heads.indexOf(active);
            if (idx === -1)
                return;
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                (_b = heads[(idx + 1) % heads.length]) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else if (e.key === 'ArrowUp') {
                e.preventDefault();
                (_c = heads[(idx - 1 + heads.length) % heads.length]) === null || _c === void 0 ? void 0 : _c.focus();
            }
            else if (e.key === 'Home') {
                e.preventDefault();
                (_d = heads[0]) === null || _d === void 0 ? void 0 : _d.focus();
            }
            else if (e.key === 'End') {
                e.preventDefault();
                (_e = heads[heads.length - 1]) === null || _e === void 0 ? void 0 : _e.focus();
            }
        };
    }
    get items() {
        var _a;
        const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot');
        const nodes = slot
            ? slot.assignedElements({ flatten: true })
            : [];
        return nodes.filter(n => n.tagName.toLowerCase() === 'footer-accordion-item');
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('fa-toggle', this.onItemToggle);
        this.addEventListener('keydown', this.onKeyNav);
    }
    disconnectedCallback() {
        this.removeEventListener('fa-toggle', this.onItemToggle);
        this.removeEventListener('keydown', this.onKeyNav);
        super.disconnectedCallback();
    }
    render() {
        return $ `<div class="footer-accordion" role="region" aria-label="Footer accordion"><slot></slot></div>`;
    }
}
FooterAccordion.styles = css_248z;
customElements.define('footer-accordion', FooterAccordion);

export { FooterAccordion };
